const loginResponse = ( response ) => {
    return {
        type: 'LOGIN_RESPONSE',
        payload: response
    }
}
const emailId = ( response ) => {
    return {
        type: 'Email_ID',
        payload: response
    }
}
const fetchTimeEntries = ( response ) => {
    return {
        type: 'Time_Entries',
        payload: response
    }
}
const imagedata = ( response ) => {
    return {
        type: 'Image_Data',
        payload: response
    }
}
const workedhours = ( response ) => {
    return {
        type: 'Worked_Hours',
        payload: response
    }
}

const timeentries = ( response ) => {
    return {
        type: 'TIME_ENTRIES',
        payload: response
    }
}
const orgid = ( response ) => {
    return {
        type: 'ORG_ID',
        payload: response
    }
}

const DocumentDisplay = ( response ) => {
    return {
        type: 'Document',
        payload: response
    }
}

const registerePayload = ( response ) => {
    return {
        type: 'REGISTER_PAYLOAD',
        payload: response
    }
}

const approvaldata = ( response ) => {
    return {
        type: 'APPROVAL_DATA',
        payload: response
    }
}

const organisationData = ( response ) => {
    return {
        type: 'ORGANISATION_DATA',
        payload: response
    }
}

// Location filter actions for global location filtering
const setLocationFilter = (locationId, locationData = null) => {
    return {
        type: 'SET_LOCATION_FILTER',
        payload: { locationId, locationData }
    }
}

const clearLocationFilter = () => {
    return {
        type: 'CLEAR_LOCATION_FILTER'
    }
}

// Super Admin organization filter actions (for viewing data as specific org)
const setSuperAdminOrgFilter = (orgId, orgData = null) => {
    return {
        type: 'SET_SUPERADMIN_ORG_FILTER',
        payload: { orgId, orgData }
    }
}

const clearSuperAdminOrgFilter = () => {
    return {
        type: 'CLEAR_SUPERADMIN_ORG_FILTER'
    }
}

// Organization suspension status actions
const setOrgSuspensionStatus = (isSuspended, suspensionReason = null, suspendedAt = null) => {
    return {
        type: 'SET_ORG_SUSPENSION_STATUS',
        payload: { isSuspended, suspensionReason, suspendedAt }
    }
}

const clearOrgSuspensionStatus = () => {
    return {
        type: 'CLEAR_ORG_SUSPENSION_STATUS'
    }
}

export {organisationData,approvaldata,registerePayload,loginResponse,DocumentDisplay,emailId,imagedata,fetchTimeEntries,timeentries,orgid,workedhours,setLocationFilter,clearLocationFilter,setSuperAdminOrgFilter,clearSuperAdminOrgFilter,setOrgSuspensionStatus,clearOrgSuspensionStatus};


